import React from 'react';
import { ArrowRight, ExternalLink, TrendingUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Portfolio.css';
import { caseStudies } from '../data/mock';

const Portfolio = () => {
  return (
    <div className="portfolio-page">
      {/* Hero */}
      <section className="portfolio-hero">
        <div className="container text-center">
          <h1 className="display-large mb-3 fade-in">
            Transforming Businesses with <span className="gradient-text">Proven Results</span>
          </h1>
          <p className="body-large fade-in" style={{ animationDelay: '0.1s' }}>
            Real projects, real impact. See how we've helped businesses achieve exponential growth through intelligent digital solutions.
          </p>
        </div>
      </section>

      {/* Case Studies */}
      <section className="section">
        <div className="container">
          {caseStudies.map((study, index) => (
            <div key={study.id} className={`case-study-card ${index % 2 === 0 ? 'reverse' : ''} fade-in`} style={{ animationDelay: `${index * 0.15}s` }}>
              <div className="case-study-image">
                <img src={study.image} alt={study.title} />
                <div className="case-study-overlay">
                  <span className="industry-tag">{study.industry}</span>
                </div>
              </div>
              <div className="case-study-content">
                <h2 className="heading-1 mb-2">{study.title}</h2>
                <div className="client-info mb-3">
                  <span className="client-name">{study.client}</span>
                  <span className="duration">{study.duration} project</span>
                </div>

                <div className="case-study-section mb-3">
                  <h4 className="section-label">Challenge</h4>
                  <p className="body-medium">{study.challenge}</p>
                </div>

                <div className="case-study-section mb-3">
                  <h4 className="section-label">Solution</h4>
                  <p className="body-medium">{study.solution}</p>
                </div>

                <div className="case-study-results mb-3">
                  <h4 className="section-label mb-2">Results</h4>
                  <div className="results-grid">
                    <div className="result-item">
                      <TrendingUp size={20} className="result-icon" />
                      <span>{study.results.metric1}</span>
                    </div>
                    <div className="result-item">
                      <TrendingUp size={20} className="result-icon" />
                      <span>{study.results.metric2}</span>
                    </div>
                    <div className="result-item">
                      <TrendingUp size={20} className="result-icon" />
                      <span>{study.results.metric3}</span>
                    </div>
                  </div>
                </div>

                <div className="technologies mb-4">
                  <h4 className="section-label mb-2">Technologies</h4>
                  <div className="tech-tags">
                    {study.technologies.map((tech, idx) => (
                      <span key={idx} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>

                <Link to="/contact" className="btn-secondary">
                  Start Your Project
                  <ArrowRight size={20} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Stats Section */}
      <section className="section portfolio-stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card glass-card text-center">
              <div className="stat-number gradient-text">500+</div>
              <div className="stat-description">Projects Delivered</div>
            </div>
            <div className="stat-card glass-card text-center">
              <div className="stat-number gradient-text">2000+</div>
              <div className="stat-description">Happy Clients Worldwide</div>
            </div>
            <div className="stat-card glass-card text-center">
              <div className="stat-number gradient-text">98%</div>
              <div className="stat-description">Client Satisfaction Rate</div>
            </div>
            <div className="stat-card glass-card text-center">
              <div className="stat-number gradient-text">25+</div>
              <div className="stat-description">Countries Served</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section">
        <div className="container">
          <div className="portfolio-cta glass-card text-center">
            <h2 className="display-medium mb-3">Ready to Write Your Success Story?</h2>
            <p className="body-large mb-4">
              Let's transform your business challenges into measurable success. Schedule a free consultation to get started.
            </p>
            <Link to="/contact" className="btn-primary btn-large">
              Book Free Consultation
              <ArrowRight size={22} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
